var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotspots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16 34.7c-3.7-1.5-6.8-4.4-8.3-8.5-2.8-7.5 1-15.9 8.6-18.7s15.9 1 18.7 8.6c2.8 7.5-1 15.9-8.6 18.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M16.5 14.1s8.4-2.4 8.8 3c0 0 .8 2.5-4.4 4.4-5.6 2-4.3 5.7-3.7 6.4.5.6 2.5 3 8.7 1.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.3,
    cy: 35.9,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotspots);
export default __webpack_public_path__ + "static/media/hotspots.9068f58faa32675e8c02f9325b6dc410.svg";
export { ForwardRef as ReactComponent };